import React from 'react';
import SliderShowContainer from '../../components/configure/slideShow/SliderShow';

const SliderShow = () => {
  return <SliderShowContainer />;
};

export default SliderShow;
